import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f02e6a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "customer-container"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Make a Payment")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add Credit")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Fees/Products")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Edit profile ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Rent a unit ")
const _hoisted_7 = { class: "alert-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Lien Status", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Auction Status", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Locked out rentals: ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-top":"20px"} }, "Customer information", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "row horizontal-start" }
const _hoisted_15 = { class: "small-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Photo Identification", -1))
const _hoisted_17 = { class: "column" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Add Photo ")
const _hoisted_20 = {
  key: 1,
  class: "btn btn-text"
}
const _hoisted_21 = { class: "box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contact", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Name:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Email:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Phone:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Cell Phone:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Address:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Edit profile", -1))
const _hoisted_29 = { class: "box" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Accounts & Access", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Login:", -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Username:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Security question:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Security answer:", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Login not created. Go to \"Edit Profile\" to add info", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Inactive Recurring Billing Account")
const _hoisted_43 = { style: {"margin-bottom":"15px"} }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Make a Payment")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Edit Recurring Billing")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rentals", -1))
const _hoisted_47 = { class: "alert-box" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Lien Status", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Customer has a Auction Status", -1))
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 0,
  class: "row horizontal-between"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Unit", -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "column" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Lease Agreement", -1))
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 2,
  style: {"color":"rgb(194, 22, 22) !important"}
}
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Sending Lease Agreement")
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Resend Lease Agreement")
const _hoisted_62 = {
  key: 3,
  style: {"color":"green"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Details", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Size", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Status:", -1))
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Gate Key:", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Access Code:", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Davinci Lock Code:", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Move-in Date:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tenant Protection Plan:", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Insurance Plan:", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Self-Insured:", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = {
  key: 7,
  style: {"color":"red"}
}
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Edit Rental")
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Billing", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Next Bill:", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Paid to:", -1))
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Move Out", -1))
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" Finalize Move Out ")
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Schedule Move Out ")
const _hoisted_89 = { key: 2 }
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_91 = {
  key: 1,
  class: "custom-box delete-box"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to cancel move out?", -1))
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["onClick"]
const _hoisted_95 = {
  key: 2,
  class: "text-center"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Reservations", -1))
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { class: "row horizontal-between" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Unit", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Details", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Size", -1))
const _hoisted_103 = { key: 0 }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Date Reserved:", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Desired Move-in Date:", -1))
const _hoisted_106 = { key: 1 }
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_108 = {
  key: 0,
  class: "custom-box delete-box"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to cancel reservation?", -1))
const _hoisted_110 = ["onClick"]
const _hoisted_111 = ["onClick"]
const _hoisted_112 = {
  key: 1,
  class: "text-center"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Billing History", -1))
const _hoisted_114 = { class: "" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Date")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Item")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Description")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Charge")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Payments/Voids")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, "Balance")
], -1))
const _hoisted_117 = { key: 0 }
const _hoisted_118 = { key: 1 }
const _hoisted_119 = { key: 2 }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_122 = { key: 3 }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_124 = { key: 4 }
const _hoisted_125 = /*#__PURE__*/_createTextVNode("Check")
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_128 = { key: 5 }
const _hoisted_129 = /*#__PURE__*/_createTextVNode("FAILED")
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_131 = /*#__PURE__*/_createTextVNode(" REFUND ")
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_133 = {
  key: 1,
  class: "text-center"
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1))
const _hoisted_135 = { class: "" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Please remember to add your name at the end of the tenant note", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_138 = { class: "form-field" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Attachment", -1))
const _hoisted_140 = ["disabled"]
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { style: {"max-width":"60vw"} }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_144 = { class: "note-body" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_146 = ["href"]
const _hoisted_147 = { key: 0 }
const _hoisted_148 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_149 = ["onClick"]
const _hoisted_150 = { key: 2 }

import { ref, onMounted, computed } from "vue";

import api from "@virgodev/bazaar/functions/api";
// import post_or_put from "../../src/api";
// import isObjectEmpty from "@/methods/is_object_empty";
// const router = useRouter();
import moment from "moment";

import { RentalInterface, ReservationInterface } from "@/types/customers";
import BaseSpinner from "@/components/BaseSpinner.vue";
import OutstandingFeeBanner from "@/components/OutstandingFeeBanner.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const customer = ref();
const userInfo = ref();
const errors = ref("");
const rentals = ref();
const noteBody = ref("");
const notes = ref();
const reservations = ref();
const lineItems = ref();
const refunds = ref();
const insurancePlans = ref();
const tenantProtectionPlans = ref();
const noteattach = ref();
const fileInput = ref<HTMLInputElement | null>(null);
const transactions = ref();
const leaseSending = ref("loaded");
const rentalLease = ref();
const lockedOutRentals = ref(Array<{ name: string }>());
const billingItems = ref();
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const deleteBox = ref(null);
const deleteReservation = ref(null);
const status = ref("loading");
const customerLien = ref(false);
const customerAuction = ref(false);
// const rentals = ref([]);
const recurringBilling = ref(false);
// const items: Item[] = [];


// Fallback for ghost accounts (no name) so RouterLinks requiring customerName don't fail
const customerNameForRoute = computed(() => {
  const c = customer.value;
  if (!c) return "Unknown";
  const name =
    c.name?.trim() ||
    [c.first_name, c.last_name].filter(Boolean).join(" ").trim();
  return name || `Customer-${c.id}`;
});

onMounted(async () => {
  status.value = "loading";
  getCustomer();
  getPaymentAccounts();
  getRentals();
  getNotes();

  await getLineItems();
  await getRefunds();
  await getTransactions();
  let items = [].concat(lineItems.value, refunds.value, transactions.value);
  items = items.sort(
    (a: { created_at: string }, b: { created_at: string }) =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      moment(a.created_at).format("YYYYMMDD") -
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      moment(b.created_at).format("YYYYMMDD")
  );

  billingItems.value = items.reverse();
  getReservations();
  status.value = "loaded";
});

async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?facilityId=${props.facilityId}&id=${props.id}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
    await getUserInfo();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
function uploadFile(e: Event) {
  const fileInput = e.target as HTMLInputElement;
  const file = (fileInput.files as FileList)[0];

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (e) => {
    if (e.target) {
      noteattach.value = e.target.result;
    }
  };
}
async function createNote() {
  formErrors.value = {};
  formSubmitting.value = true;
  let body = new FormData();
  if (
    fileInput.value &&
    fileInput.value.files &&
    fileInput.value.files.length > 0
  ) {
    body.append("attachment", fileInput.value.files[0]);
  }
  body.append("body", noteBody.value);
  if (noteBody.value && noteBody.value.length) {
    let url = "notes/?id=" + props.id + `&facilityId=${props.facilityId}`;
    let method: "POST" | "PATCH" = "POST";
    const response = await api({
      url,
      method,
      body,
    });

    if ([200, 201].includes(response.status)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      notes.value.unshift(response.body);
      fileInput.value = null;
      noteBody.value = "";
      formSubmitting.value = false;
    } else {
      formErrors.value = {
        non_field_errors: [
          "Unable to communicate with the server. Please check your " +
            "connection and try again.",
        ],
      };
    }
  }
}

async function cancelMoveOut(id: string) {
  errors.value = "";
  const response = await api({
    url: `cancel_move_out/?id=${id}&facilityId=${props.facilityId}`,
    method: "PUT",
  });
  if (response.status == 200) {
    deleteBox.value = null;
    await getRentals();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function resendAgreement(id: string) {
  rentalLease.value = id;
  leaseSending.value = "sending";
  const response = await api({
    url: `resend_agreement/?rental_id=${id}&customer_id=${props.id}&facilityId=${props.facilityId}`,
    method: "POST",
  });

  if (response.status == 200) {
    leaseSending.value = "sent";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function cancelReserve(reservation: ReservationInterface) {
  errors.value = "";
  const response = await api({
    url: `reservations/?id=${reservation.id}&facilityId=${props.facilityId}`,
    method: "DELETE",
  });
  if (response.status == 200) {
    deleteReservation.value = null;
    await getReservations();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

function isTalkdeskNote(note: { body?: string }) {
  return note?.body && String(note.body).toLowerCase().includes("talkdesk");
}

async function getNotes() {
  errors.value = "";
  const response = await api({
    url: `notes/?id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    notes.value = response.body;
    let items = notes.value;
    notes.value = items
      .sort(
        (a: { created_at: string }, b: { created_at: string }) =>
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          moment(a.created_at).format("YYYYMMDD") -
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          moment(b.created_at).format("YYYYMMDD")
      )
      .reverse();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getLineItems() {
  errors.value = "";
  const response = await api({
    url: `line_items/?id=${props.id}&facilityId=${props.facilityId}&paid=any`,
  });
  if (response.status == 200) {
    lineItems.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getRefunds() {
  errors.value = "";
  const response = await api({
    url: `refunds/?id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    refunds.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getTransactions() {
  errors.value = "";
  const response = await api({
    url: `transactions/?customer_id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    transactions.value = response.body;
  } else if (response.status != 404) {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getReservations() {
  errors.value = "";
  const response = await api({
    url: `reservations/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body) {
      let reservationList = response.body;
      reservations.value = reservationList.filter(
        (item: ReservationInterface) => item.customer_id == props.id
      );
      for (let reservation of reservations.value) {
        let details = await getUnit(reservation);
        reservation.details = details;
        let unit_type = await getUnitTypes(reservation.details.unit_type_id);
        reservation.unit_type = unit_type;
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function deleteNote(id: string) {
  const response = await api({
    url: `notes/?id=${id}&facilityId=${props.facilityId}`,
    method: "DELETE",
  });
  if (response.status == 200) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let index = notes.value.findIndex(function (item: any) {
      return item.id === id;
    });
    if (index != -1) {
      notes.value.splice(index, 1);
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUserInfo() {
  errors.value = "";
  const response = await api({
    url: `users/?id=${customer.value.user_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    userInfo.value = response.body;
  } else if (response.status != 404) {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
function titleCase(string: string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
}
async function getRentals() {
  await getProtectionPlans();
  await getInsurances();
  status.value = "loading";
  errors.value = "";
  const response = await api({
    url: `rentals/?id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    rentals.value = response.body;
    for (let rental of rentals.value) {
      let details = await getUnit(rental);
      rental.details = details;
      if (rental.details.status == "lien") {
        customerLien.value = true;
      } else if (rental.details.status == "auction") {
        customerAuction.value = true;
      }
      if (rental.details.status == "locked_out") {
        lockedOutRentals.value.push({
          name: rental.details.name,
        });
      }

      let unit_type = await getUnitTypes(rental.details.unit_type_id);
      rental.unit_type = unit_type;
      if (rental.tenant_protection_plan_id) {
        rental.tenant_protection = tenantProtectionPlans.value.filter(
          (item: { id: number }) => item.id == rental.tenant_protection_plan_id
        )[0];
      }
      if (rental.insurance_policy_id) {
        rental.insurance_policy = insurancePlans.value.filter(
          (item: { id: number }) => item.id == rental.insurance_policy_id
        )[0];
      }
    }
    status.value = "loaded";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnit(item: RentalInterface | ReservationInterface) {
  errors.value = "";
  const response = await api({
    url: `units/?id=${item.unit_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  return null;
}
async function getUnitTypes(id: string) {
  errors.value = "";
  const response = await api({
    url: `unit_types/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  return null;
}

async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let accounts = response.body;
    for (let account of accounts) {
      if (account.active) {
        recurringBilling.value = true;
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getProtectionPlans() {
  errors.value = "";
  const response = await api({
    url: `tenant_protection_plans/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    tenantProtectionPlans.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getInsurances() {
  errors.value = "";
  const response = await api({
    url: `insurance_policies/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    insurancePlans.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (customer.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (status.value === 'loading')
          ? (_openBlock(), _createBlock(BaseSpinner, {
              key: 0,
              preset: "large"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("h1", null, _toDisplayString(_unref(customerNameForRoute)), 1),
        _createVNode(OutstandingFeeBanner, {
          "facility-id": __props.facilityId,
          "customer-id": __props.id
        }, null, 8, ["facility-id", "customer-id"]),
        _createVNode(_component_RouterLink, {
          to: {
        name: 'payment',
        params: {
          customerId: customer.value.id,
          customerName: _unref(customerNameForRoute),
          facilityId: __props.facilityId,
        },
      },
          class: "btn btn-text"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          to: {
        name: 'credit',
        params: {
          customerId: customer.value.id,
          customerName: _unref(customerNameForRoute),
          facilityId: __props.facilityId,
        },
      },
          class: "btn btn-text"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          to: {
        name: 'fee_product',
        params: {
          customerId: customer.value.id,
          customerName: _unref(customerNameForRoute),
          facilityId: __props.facilityId,
        },
      },
          class: "btn btn-text"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          to: {
        name: 'customer',
        params: { customerId: __props.id, facilityId: __props.facilityId, rental: 'false' },
      },
          class: "btn btn-text"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          to: {
        name: 'rental',
        params: {
          customerId: __props.id,
          facilityId: __props.facilityId,
          unitStatus: 'available',
        },
      },
          class: "btn btn-text"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("div", _hoisted_7, [
          (customerLien.value)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 0,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (customerAuction.value)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 1,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (customer.value.notes)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 2,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, " Note: " + _toDisplayString(customer.value.notes), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (customer.value.locked_out_at)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 3,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, " Locked out on: " + _toDisplayString(_unref(moment)(customer.value.locked_out_at).format("YYYY-MM-DD")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (lockedOutRentals.value && lockedOutRentals.value.length)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 4,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lockedOutRentals.value, (lockedOut) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: lockedOut.name + 'lockedOut'
                      }, [
                        _createTextVNode(" Unit " + _toDisplayString(lockedOut.name) + " ", 1),
                        _hoisted_11
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _hoisted_12,
        (customer.value.archived_at)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Archived at " + _toDisplayString(customer.value.archived_at), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("fieldset", _hoisted_17, [
              _createElementVNode("img", {
                src: customer.value.photo_identification,
                class: "photo-id"
              }, null, 8, _hoisted_18),
              _createVNode(_component_RouterLink, {
                to: {
              name: 'customer_photos',
              params: {
                customerId: customer.value.id,
                customerName: _unref(customerNameForRoute),
                facilityId: __props.facilityId,
              },
            }
              }, {
                default: _withCtx(() => [
                  (!customer.value.photo_identification)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_19
                      ], 64))
                    : (_openBlock(), _createElementBlock("button", _hoisted_20, "See More"))
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("fieldset", null, [
              _hoisted_23,
              _createElementVNode("p", null, _toDisplayString(_unref(customerNameForRoute)), 1),
              _hoisted_24,
              _createElementVNode("p", null, _toDisplayString(customer.value.email), 1),
              _hoisted_25,
              _createElementVNode("p", null, _toDisplayString(customer.value.formatted_phone), 1),
              _hoisted_26,
              _createElementVNode("p", null, _toDisplayString(customer.value.formatted_cell_phone), 1),
              _hoisted_27,
              _createElementVNode("p", null, _toDisplayString(customer.value.address), 1),
              _createVNode(_component_RouterLink, {
                to: {
              name: 'customer',
              params: {
                customerId: __props.id,
                facilityId: __props.facilityId,
                rental: 'false',
              },
            }
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (userInfo.value)
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_31, [
                  _hoisted_32,
                  (userInfo.value.login_is_disabled)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Disabled"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_34, "Enabled")),
                  _hoisted_35,
                  _createElementVNode("p", null, _toDisplayString(userInfo.value.username), 1),
                  _hoisted_36,
                  _createElementVNode("p", null, _toDisplayString(customer.value.security_question), 1),
                  _hoisted_37,
                  _createElementVNode("p", null, _toDisplayString(customer.value.security_answer), 1)
                ]))
              : (_openBlock(), _createElementBlock("fieldset", _hoisted_38, _hoisted_40))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(!recurringBilling.value ? 'alert-box-2' : '')
        }, [
          (recurringBilling.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_41, "Active Recurring Billing Account"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_42
              ], 64))
        ], 2),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("h2", null, "Balance: $" + _toDisplayString(customer.value.balance), 1)
        ]),
        _createVNode(_component_RouterLink, {
          to: {
        name: 'payment',
        params: {
          customerId: customer.value.id,
          customerName: _unref(customerNameForRoute),
          facilityId: __props.facilityId,
        },
      },
          class: "btn btn-text"
        }, {
          default: _withCtx(() => [
            _hoisted_44
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          class: "btn btn-text",
          to: {
        name: 'payment_details',
        params: {
          customerId: customer.value.id,
          customerName: _unref(customerNameForRoute),
          facilityId: __props.facilityId,
        },
      }
        }, {
          default: _withCtx(() => [
            _hoisted_45
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          (customerLien.value)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 0,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _hoisted_48
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (customerAuction.value)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 1,
                variant: "danger",
                class: "js-form-error"
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("fieldset", null, [
          (status.value === 'loading')
            ? (_openBlock(), _createBlock(BaseSpinner, {
                key: 0,
                preset: "large"
              }))
            : (rentals.value && rentals.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rentals.value, (rental) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: rental.id + 'rental',
                      class: "rental-box"
                    }, [
                      (rental.details && rental.unit_type)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _createElementVNode("div", null, [
                              _hoisted_52,
                              (rental.details)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_53, _toDisplayString(rental.details.name), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              (rental.agreement_signed_externally_at)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_56, " Signed on " + _toDisplayString(rental.agreement_signed_externally_at.split(" ")[0]), 1))
                                : (rental.agreement_signed_at)
                                  ? (_openBlock(), _createElementBlock("h3", _hoisted_57, " Signed on " + _toDisplayString(rental.agreement_signed_at.split(" ")[0]), 1))
                                  : (_openBlock(), _createElementBlock("h3", _hoisted_58, " Unsigned ")),
                              _createElementVNode("button", {
                                class: "btn btn-text",
                                disabled: 
                  leaseSending.value == 'sending' && rentalLease.value == rental.id
                ,
                                onClick: ($event: any) => (resendAgreement(rental.id))
                              }, [
                                (leaseSending.value == 'sending' && rentalLease.value == rental.id)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_60
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_61
                                    ], 64))
                              ], 8, _hoisted_59),
                              (rentalLease.value == rental.id && leaseSending.value == 'sent')
                                ? (_openBlock(), _createElementBlock("small", _hoisted_62, "Agreement successfully sent"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_63,
                              _hoisted_64,
                              _createElementVNode("p", null, [
                                _createTextVNode(" Size: " + _toDisplayString(rental.unit_type.length) + "x" + _toDisplayString(rental.unit_type.width) + "x" + _toDisplayString(rental.unit_type.height) + " ", 1),
                                (
                    rental.unit_type.length == 0 &&
                    rental.unit_type.width == 0 &&
                    rental.unit_type.height == 0
                  )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" - " + _toDisplayString(rental.unit_type.name), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_65,
                              (rental.details)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(rental.details.status), 1))
                                : _createCommentVNode("", true),
                              (rental.details.gate_key)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_67,
                                    _createElementVNode("p", null, _toDisplayString(rental.details.gate_key), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (rental.details.access_code)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _hoisted_68,
                                    _createElementVNode("p", null, _toDisplayString(rental.details.access_code), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (rental.details.davinci_lock_code)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _hoisted_69,
                                    _createElementVNode("p", null, _toDisplayString(rental.details.davinci_lock_code), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              _hoisted_70,
                              _createElementVNode("p", null, _toDisplayString(rental.move_in_on), 1),
                              (rental.tenant_protection)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _hoisted_71,
                                    _createElementVNode("p", null, " $" + _toDisplayString(Number(rental.tenant_protection.limit).toFixed(2)) + " protection for $" + _toDisplayString(Number(rental.tenant_protection.fee).toFixed(2)) + " per month ", 1)
                                  ], 64))
                                : (rental.insurance_policy)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _hoisted_72,
                                      _createElementVNode("p", null, " $" + _toDisplayString(Number(rental.insurance_policy.limit).toFixed(2)) + " protection for $" + _toDisplayString(Number(rental.insurance_policy.premium).toFixed(2)) + " per month ", 1)
                                    ], 64))
                                  : (rental.self_insured_policy_number)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                        _hoisted_73,
                                        _createElementVNode("p", null, [
                                          _createTextVNode(" Policy Number: " + _toDisplayString(rental.self_insured_policy_number) + " ", 1),
                                          _hoisted_74,
                                          _createTextVNode(" Provider: " + _toDisplayString(rental.self_insured_policy_provider) + " ", 1),
                                          _hoisted_75,
                                          _createTextVNode(" Policy phone: " + _toDisplayString(rental.self_insured_policy_phone) + " ", 1),
                                          _hoisted_76,
                                          _createTextVNode(" Expiration: " + _toDisplayString(rental.self_insured_policy_expires_on), 1)
                                        ])
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_77, " No protection plan added (click Edit to add one) ")),
                              _createVNode(_component_RouterLink, {
                                class: "btn",
                                to: {
                  name: 'rental_update',
                  params: {
                    customerId: __props.id,
                    rentalId: rental.id,
                    unitType: rental.unit_type.id,
                    facilityId: __props.facilityId,
                  },
                }
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_78
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_79,
                              _createElementVNode("h5", null, _toDisplayString(rental.price) + " each month", 1),
                              _hoisted_80,
                              _createElementVNode("p", null, _toDisplayString(rental.next_due_on), 1),
                              _hoisted_81,
                              _createElementVNode("p", null, _toDisplayString(rental.paid_through_ends_on), 1)
                            ]),
                            (rentals.value && rentals.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _hoisted_83,
                                  _createTextVNode(" " + _toDisplayString(rental.moved_out_at) + " ", 1),
                                  (rental.moved_out_at)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, "Moved out"))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                        (rental.move_out_on)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                              _createElementVNode("h3", null, "Move-out Scheduled: " + _toDisplayString(rental.move_out_on), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (rental.details)
                                          ? (_openBlock(), _createBlock(_component_RouterLink, {
                                              key: 1,
                                              class: "btn",
                                              to: {
                    name: 'schedule_move_out',
                    params: {
                      customerId: customer.value.id,
                      rentalId: rental.id,
                      customerName: _unref(customerNameForRoute),
                      unitName: rental.details.name,
                      unitsLeft: rentals.value.length,
                      edit: 0,
                      facilityId: __props.facilityId,
                    },
                  }
                                            }, {
                                              default: _withCtx(() => [
                                                (rental.move_out_on)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _hoisted_87
                                                    ], 64))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _hoisted_88
                                                    ], 64))
                                              ]),
                                              _: 2
                                            }, 1032, ["to"]))
                                          : _createCommentVNode("", true),
                                        (rental.move_out_on)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                              (rental.details)
                                                ? (_openBlock(), _createBlock(_component_RouterLink, {
                                                    key: 0,
                                                    class: "btn",
                                                    to: {
                      name: 'schedule_move_out',
                      params: {
                        customerId: customer.value.id,
                        rentalId: rental.id,
                        customerName: _unref(customerNameForRoute),
                        unitName: rental.details.name,
                        unitsLeft: rentals.value.length,
                        edit: 1,
                        facilityId: __props.facilityId,
                      },
                    }
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_90
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"]))
                                                : _createCommentVNode("", true),
                                              (deleteBox.value == rental.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                    _hoisted_92,
                                                    _createElementVNode("div", {
                                                      class: "btn btn-primary",
                                                      onClick: ($event: any) => (cancelMoveOut(rental.id))
                                                    }, " Yes ", 8, _hoisted_93),
                                                    _createElementVNode("div", {
                                                      class: "btn btn-primary",
                                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteBox.value = null))
                                                    }, " No ")
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 2,
                                                    class: "btn",
                                                    onClick: ($event: any) => (deleteBox.value = rental.id)
                                                  }, " Cancel ", 8, _hoisted_94))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_95, "No items yet"))
        ]),
        _hoisted_96,
        _createElementVNode("fieldset", null, [
          (reservations.value && reservations.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reservations.value, (reservation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'reservation' + reservation.id,
                    class: "rental-box"
                  }, [
                    _createElementVNode("div", _hoisted_98, [
                      (reservation.details)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                            _hoisted_100,
                            _createElementVNode("h3", null, _toDisplayString(reservation.details.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _hoisted_101,
                        _hoisted_102,
                        (reservation.unit_type)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_103, _toDisplayString(reservation.unit_type.length) + "x" + _toDisplayString(reservation.unit_type.width) + "x" + _toDisplayString(reservation.unit_type.height), 1))
                          : _createCommentVNode("", true),
                        _hoisted_104,
                        _createElementVNode("p", null, _toDisplayString(reservation.created_at), 1),
                        _hoisted_105,
                        _createElementVNode("p", null, _toDisplayString(reservation.move_in_on), 1)
                      ]),
                      (
                reservation.details && reservation.details.status == 'reserved'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                            _createVNode(_component_RouterLink, {
                              class: "btn",
                              to: {
                  name: 'rental',
                  params: {
                    customerId: __props.id,
                    unitId: reservation.details.id,
                    unitType: reservation.details.unit_type_id,
                    unitStatus: 'reserved',
                    reservationId: reservation.id,
                    facilityId: __props.facilityId,
                  },
                }
                            }, {
                              default: _withCtx(() => [
                                _hoisted_107
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            (deleteReservation.value == reservation.id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  _hoisted_109,
                                  _createElementVNode("div", {
                                    class: "btn btn-primary",
                                    onClick: ($event: any) => (cancelReserve(reservation))
                                  }, " Yes ", 8, _hoisted_110),
                                  _createElementVNode("div", {
                                    class: "btn btn-primary",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteReservation.value = null))
                                  }, " No ")
                                ]))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn",
                                  onClick: ($event: any) => (deleteReservation.value = reservation.id)
                                }, " Cancel ", 8, _hoisted_111))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_112, "No items yet"))
        ]),
        _hoisted_113,
        _createElementVNode("fieldset", _hoisted_114, [
          (billingItems.value && billingItems.value.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_115, [
                _hoisted_116,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id + 'billing_item'
                  }, [
                    (item.total)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_117, [
                          _createVNode(_component_RouterLink, {
                            to: {
                name: 'transaction',
                params: {
                  transactionId: item.id,
                  customerId: __props.id,
                  customerName: _unref(customerNameForRoute),
                  facilityId: __props.facilityId,
                },
              }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.created_at.split(" ")[0]), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.amount && !item.refund_method)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_118, [
                          _createVNode(_component_RouterLink, {
                            to: {
                name: 'line_item',
                params: {
                  lineItemId: item.id,
                  customerId: __props.id,
                  customerName: _unref(customerNameForRoute),
                  facilityId: __props.facilityId,
                },
              }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.created_at.split(" ")[0]), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    (item.due_on)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_119, [
                          _createTextVNode(_toDisplayString(titleCase(item.action)) + " Invoiced ", 1),
                          _hoisted_120,
                          _createTextVNode(" Due Date: " + _toDisplayString(item.due_on) + " ", 1),
                          _hoisted_121,
                          _createTextVNode(" " + _toDisplayString(item.description), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.amount)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_122, [
                          (item.refund_method)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(Number(item.amount).toFixed(2)) + " refund of " + _toDisplayString(item.refund_method), 1),
                                _hoisted_123,
                                _createTextVNode(" " + _toDisplayString(item.reason), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString((Number(item.amount) + Number(item.tax)).toFixed(2)), 1)
                              ], 64))
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_124, [
                          _createTextVNode(" $" + _toDisplayString(item.total) + " ", 1),
                          (item.account_summary)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" payment by " + _toDisplayString(item.account_summary), 1)
                              ], 64))
                            : (item.payment_method)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(item.payment_method), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                          (item.check_number)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _hoisted_125
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_126,
                          (item.message)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode(" Message: " + _toDisplayString(item.message), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])),
                    _hoisted_127,
                    (item.total)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_128, [
                          _createTextVNode(_toDisplayString(item.total) + " ", 1),
                          (item.message == 'Declined')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_129
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.refund_method)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(Number(item.amount).toFixed(2)) + " ", 1),
                            _hoisted_130,
                            _hoisted_131
                          ]),
                          _hoisted_132
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, "$" + _toDisplayString(item.running_balance), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_133, "No items yet"))
        ]),
        _hoisted_134,
        _createElementVNode("fieldset", _hoisted_135, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((noteBody).value = $event))
          }, null, 512), [
            [_vModelText, noteBody.value]
          ]),
          _hoisted_136,
          _hoisted_137,
          _createElementVNode("div", _hoisted_138, [
            _hoisted_139,
            _createElementVNode("input", {
              ref_key: "fileInput",
              ref: fileInput,
              type: "file",
              onChange: uploadFile
            }, null, 544)
          ]),
          _createElementVNode("button", {
            class: "btn",
            disabled: formSubmitting.value,
            onClick: createNote
          }, " Create Note ", 8, _hoisted_140),
          (notes.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: note.id + 'note',
                    class: "note"
                  }, [
                    _createElementVNode("div", _hoisted_142, [
                      _createTextVNode(_toDisplayString(note.creator_id) + " " + _toDisplayString(_unref(moment)(note.created_at).format("MM/DD/YY H:mm:ss A")), 1),
                      _hoisted_143,
                      _createElementVNode("span", _hoisted_144, _toDisplayString(note.body), 1),
                      _hoisted_145,
                      (note.attachment && note.attachment.url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: note.attachment.url
                          }, _toDisplayString(note.attachment.url), 9, _hoisted_146))
                        : _createCommentVNode("", true)
                    ]),
                    (!isTalkdeskNote(note))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                          _createVNode(_component_RouterLink, {
                            class: "btn",
                            to: {
                name: 'note',
                params: {
                  noteId: note.id,
                  customerId: __props.id,
                  customerName: _unref(customerNameForRoute),
                  facilityId: __props.facilityId,
                },
              }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_148
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("button", {
                            class: "btn",
                            onClick: ($event) => deleteNote(note.id)
                          }, " Delete ", 8, _hoisted_149)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (errors.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_150, _toDisplayString(errors.value), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})